import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Table,
	TableBody,
	TableCell,
	TableRow,
	Tooltip,
	Typography,
} from "@mui/material"
import {ExpandMore as ExpandMoreIcon} from "@mui/icons-material"
import React from "react"

import {TransactionIcon} from "./TransactionIcon"
import {ScheduledPaymentRow} from "./ScheduledPaymentRow"

import {Transaction} from "@indebted/api"

function List(props: {Transactions: Transaction[]; reload: (delayMs?: number) => void}) {
	const {Transactions, reload} = props
	// Single open panel at a time, as the Activities tab does.
	const [expandedPanel, setExpandedPanel] = React.useState<number | false>(false)
	const changeExpandedPanelTo = (panelId: number) => (_event: unknown, isExpanded: boolean) =>
		setExpandedPanel(isExpanded ? panelId : false)

	return (
		<Box sx={{width: "100%"}}>
			<Table>
				<TableBody>
					{Transactions.map((transaction, index) => {
						if (
							transaction.Type === "PaymentScheduled" &&
							transaction.CommitmentStatus === "pending" &&
							transaction.PaymentArrangementID &&
							transaction.ScheduledDate
						) {
							return (
								<TableRow key={index}>
									<TableCell colSpan={2} sx={{padding: 0}}>
										<ScheduledPaymentRow
											paymentArrangementID={transaction.PaymentArrangementID}
											title={transaction.Description}
											amount={transaction.Amount}
											scheduledDate={transaction.ScheduledDate}
											reload={reload}
										/>
									</TableCell>
								</TableRow>
							)
						}

						const {Amount, Date, Time, Type, Description, EffectiveDate, UploadedAt} = transaction

						return (
							<TableRow key={index}>
								<TableCell colSpan={2} sx={{padding: 0}}>
									<Accordion
										expanded={expandedPanel === index}
										onChange={changeExpandedPanelTo(index)}
										disableGutters
									>
										<AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{pl: 3}}>
											<Box display="flex" alignItems="center" sx={{width: "100%"}}>
												<Box display="flex" alignItems="center" flexGrow={1}>
													<TransactionIcon type={Type} />
													<Typography variant="body2">{Description}</Typography>
												</Box>
												<Box mr={2}>
													<Tooltip title={Time} placement="left">
														<Typography variant="caption" color="textSecondary">
															{Date}
														</Typography>
													</Tooltip>
												</Box>
												<Typography variant="body2">{Amount}</Typography>
											</Box>
										</AccordionSummary>
										<AccordionDetails sx={{pl: 3}}>
											{expandedPanel === index && (
												<>
													{/* Only the client-upload rows carry a date the client
														stated, so the field is left out where there is none. */}
													{EffectiveDate && (
														<Box mb={2}>
															<Typography variant="body2">
																<strong>Effective date:</strong>
															</Typography>
															<Typography variant="body2" color="textSecondary">
																{EffectiveDate}
															</Typography>
														</Box>
													)}
													<Box mb={2}>
														<Typography variant="body2">
															<strong>Processed:</strong>
														</Typography>
														<Typography variant="body2" color="textSecondary">
															{Time}
														</Typography>
													</Box>
													{/* A charge or compensation records no upload time. */}
													{UploadedAt && (
														<Box mb={2}>
															<Typography variant="body2">
																<strong>Uploaded:</strong>
															</Typography>
															<Typography variant="body2" color="textSecondary">
																{UploadedAt}
															</Typography>
														</Box>
													)}
												</>
											)}
										</AccordionDetails>
									</Accordion>
								</TableCell>
							</TableRow>
						)
					})}
				</TableBody>
			</Table>
		</Box>
	)
}

export {List}
